import { useState } from 'react';

export default function WhatsAppChat() {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '919925898625'; // WhatsApp number in international format without + or spaces
  const message = 'Hello! I would like to know more about your services.';

  const handleStartChat = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {/* Chat Preview */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-80 bg-white rounded-2xl shadow-2xl z-50 overflow-hidden animate-slideUp">
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <i className="ri-whatsapp-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-base">Urban Spaces</h3>
                  <p className="text-xs text-white/90">Typically replies instantly</p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="w-8 h-8 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
          </div>

          <div className="p-6 bg-gray-50">
            <div className="bg-white rounded-lg p-4 shadow-sm mb-4">
              <p className="text-sm text-gray-700 mb-2">
                👋 Hi there! Welcome to Urban Spaces.
              </p>
              <p className="text-sm text-gray-700">
                How can we help you today? Click below to start chatting with us on WhatsApp!
              </p>
            </div>

            <button
              onClick={handleStartChat}
              className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-2.5 rounded-lg font-medium text-sm hover:from-green-600 hover:to-green-700 transition-all cursor-pointer whitespace-nowrap"
            >
              Start Chat
            </button>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform z-50 cursor-pointer group"
      >
        <i className={`ri-${isOpen ? 'close' : 'whatsapp'}-line text-white text-3xl`}></i>
        
        {/* Pulse Animation */}
        {!isOpen && (
          <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75"></span>
        )}
        
        {/* Notification Badge */}
        {!isOpen && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold">1</span>
          </span>
        )}
      </button>
    </>
  );
}
